/**
 * 统一加载状态组件
 */
import React, { memo } from 'react';
import { Spin } from 'antd';

/**
 * 全屏加载组件
 * @param {Object} props
 * @param {string} props.tip - 加载提示文本
 * @param {string} props.size - 加载图标大小: 'small' | 'default' | 'large'
 * @param {string} props.height - 容器最小高度
 * @param {string} props.className - 自定义类名
 */
const LoadingOverlay = ({
  tip = '加载中...',
  size = 'large',
  height = '100vh',
  className = ''
}) => {
  return (
    <div
      className={`loading-container ${className}`}
      style={{ minHeight: height }}
    >
      <Spin size={size} tip={tip} />
    </div>
  );
};

export default memo(LoadingOverlay);

/**
 * 行内加载组件
 */
export const InlineLoading = ({ tip = '加载中...', size = 'small' }) => {
  return <Spin size={size} tip={tip} />;
};

/**
 * 按钮加载状态包装组件
 */
export const ButtonLoading = ({ loading, children, ...props }) => {
  return (
    <>
      {children}
      {loading && (
        <span style={{ marginLeft: 8 }}>
          <Spin size="small" />
        </span>
      )}
    </>
  );
};